import { render, staticRenderFns } from "./QuestionMap.vue?vue&type=template&id=2424ab0c&scoped=true&"
import script from "./QuestionMap.vue?vue&type=script&lang=ts&"
export * from "./QuestionMap.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionMap.vue?vue&type=style&index=0&lang=less&"
import style1 from "./QuestionMap.vue?vue&type=style&index=1&id=2424ab0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424ab0c",
  null
  
)

export default component.exports